import { ProfileOverview } from '@lib.core/entities/profile/profile-overview';
import { ProfileSummaryDTO } from '@lib.resources/profile/dtos/profile-summary';
import { KPIDTO } from '@lib.resources/indicator/dtos/kpi';
import { newLocationEntityFromDto } from '@lib.resources/location/dtos/location';
import { newTopicFromDto } from '@lib.resources/topic/dtos/topic';

export interface ProfileInstanceDTO {
  instanceHashKey: string;
  profileSummary: ProfileSummaryDTO;
}

export function newProfileOverviewFromDTO(profileInstance: ProfileInstanceDTO) {
  const profileHashKey = profileInstance.instanceHashKey;
  const {
    title,
    nameid,
    description,
    kpis,
    topics,
    isSubscribed,
    imageUrl,
    lastUpdatedAt,
    subtitle,
    sectors,
    location,
  } = profileInstance.profileSummary;

  return new ProfileOverview(
    profileHashKey,
    nameid,
    title,
    description,
    new Date(Date.parse(lastUpdatedAt)),
    kpis?.map(dto => KPIDTO.toKPI(dto)),
    topics
      .map((topic) => newTopicFromDto(topic)[0])
      .filter(
        (topic, index, array) =>
          array.map((t) => t.nameId).indexOf(topic.nameId) === index
      ),
    isSubscribed,
    imageUrl,
    subtitle,
    sectors?.map(sector => ({ sectorId: sector.id })),
    location ? newLocationEntityFromDto(location) : undefined,
  );
}
